import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { InvoiceEditComponent } from './pages/invoice-edit/invoice-edit.component';
import { AuthGuard } from '../auth/guards/auth.guard';
import { InvoiceRollbackComponent } from './pages/invoice-rollback/invoice-rollback.component';
import { InvoiceViewPdfComponent } from './pages/invoice-view-pdf/invoice-view-pdf.component';
import { InvoiceEmailHistoryComponent } from './pages/invoice-email-history/invoice-email-history.component';
import { CreditNoteComponent } from './pages/credit-note/credit-note.component';
import { SageExportBuildComponent } from './pages/sage-export-build/sage-export-build.component';
import { SageExportBatchesComponent } from './pages/sage-export-batches/sage-export-batches.component';
import { SageExportConfirmComponent } from './pages/sage-export-confirm/sage-export-confirm.component';
import { SageTaxCodesComponent } from './pages/sage-tax-codes/sage-tax-codes.component';


const routes: Routes = [
  {
    path: 'invoices',
    component: InvoicesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'invoices/edit/:id',
    component: InvoiceEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'invoices/rollback/:id',
    component: InvoiceRollbackComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'invoices/pdf/:id',
    component: InvoiceViewPdfComponent,
  },
  {
    path: 'invoices/email-history',
    component: InvoiceEmailHistoryComponent,
  },
  {
    path: 'credit-note',
    component: CreditNoteComponent,
  },
  // The Sage 50 export. Guarded, unlike `invoices/pdf/:id` and `invoices/email-history` above -
  // these four read and write accounts data, and one of them records that invoices reached the
  // sales ledger.
  {
    path: 'invoices/sage-export',
    component: SageExportBuildComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'invoices/sage-export/batches',
    component: SageExportBatchesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'invoices/sage-export/batches/:batchRef',
    component: SageExportConfirmComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'invoices/sage-export/tax-codes',
    component: SageTaxCodesComponent,
    canActivate: [AuthGuard],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InvoiceRoutingModule { }
